<template>
  <div v-if="showDialog">
    <div id="zheZao1">
      <transition name="pop" appear>
        <div class="modal" role="dialog" id="info">

          <div style="text-align: center;margin-bottom: 44px;margin-top: 25px;font-size: 18px;
            font-weight: 600;
            color: #000000;
            line-height: 25px;
            font-style: normal;">
            {{ info }}
          </div>

          <div class="model-body" v-if="!info">
            <div class="question">
              <img-modal>{{ $t('guide.about') }} <i class="el-icon-question"></i></img-modal>
            </div>
            <input v-model="dogTagId"
              :placeholder="$t('guide[\'Please enter the dog tag ID.\']')"
              type="text" maxlength="32">
            <div class="info">
              {{ $t('guide.info[3]') }}
            </div>
          </div>

          <div class="footer_btn">
            <div class="dis_in_center" v-if="showConfirmButton">
              <div
                @click="confirm"
                style="width: 100%;
              color: #FFFFFF;
              line-height: 48px;
              height: 48px;
              background: linear-gradient( 133deg, #F8B029 0%, #F6923D 100%);
              border-radius: 14px;">
                {{ confirmText }}
              </div>
            </div>
          </div>
        </div>
      </transition>

      <img
        class="label_1"
        referrerpolicy="no-referrer"
        src="../components/close.png"
        @click="close"
      />
    </div>
  </div>
</template>
<script>
import { i18n } from "../main";
import ImgModal from "./ImgModal.vue";
export default {
  name: 'CustomDialog',
  components: {ImgModal},
  model: {
    prop: 'showDialog',
    event: 'change'
  },
  data() {
    return {
      $t: i18n.t,
      showImgModal: false
    }
  },
  props: {
    dogTagId: {
      type: String,
      default: ''
    },
    // 弹框的显示隐藏
    info: {
      type: String,
      default: ''
    },
    // 弹框的显示隐藏
    showDialog: {
      type: Boolean,
      default: false
    },
    // 底部按钮大小
    size: {
      type: String,
      default: 'medium'
    },
    // 宽度设置
    width: {
      type: [String, Number],
      default: '500'
    },
    // 是否显示右上角的关闭按钮
    showClose: {
      type: Boolean,
      default: true
    },
    // 弹框标题
    title: {
      type: String,
      default: 'Notification'
    },
    // 确认按钮
    confirmText: {
      type: String,
      default: 'Save'
    },
    // 确认按钮loading
    confirmBtnLoading: {
      type: Boolean,
      default: false
    },
    // 是否显示确认按钮
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    // 是否显示取消按钮
    showCancelButton: {
      type: Boolean,
      default: true
    },
    // 是否禁用确认按钮
    disabled: {
      type: Boolean,
      default: false
    },
    // 确认按钮类型
    confirmBtnType: {
      type: String,
      default: 'primary'
    },
    // 取消按钮类型
    cancelType: {
      type: String,
      default: 'primary'
    },
    // 取消按钮文本
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    // 关闭按钮前的事件处理
    beforeClose: {
      type: Function,
      default: () => {
        return true;
      }
    }
  },
  methods: {
    close() {
      const data = this.beforeClose();
      if (!data) return;
      this.$emit('change', false);
    },
    confirm() {
      this.$emit('confirm', this.dogTagId);
    }
  }
};
</script>
<style scoped>
#zheZao1 {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(7, 7, 7, 0.78);
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5vh;
}

#zheZao1 .modal {
  width: 70vw;
  height: fit-content;
  overflow: hidden;
  background: #fff;
  z-index: 4;
  transform: none;
  background: linear-gradient(180deg, #FFFFFF 0%, #E6F3DC 100%);
  border-radius: 57px;
}

#zheZao1 .model-body {
  text-align: left;
  margin-bottom: 44px;
  display: flex;
  flex-direction: column;
  gap: .1em;
}
.model-body .question {
  margin-left: auto;
}
.model-body .info {
  font-size: .9em;
  margin-top: .2em;
}
#zheZao1 .model-body input {
  line-height: 52px;
  padding: 0 15px;
  height: 52px;
  background: #F9F9FA;
  border-radius: 18px;
  border: 1px solid #F6943C;
}

#zheZao1 .icon-close i {
  cursor: pointer;
}

#zheZao1 .footer_btn {
  text-align: center;
  padding-bottom: 20px;
  border-top: 1px solid #f5f5f5;
}

#zheZao1 .dis_in_center {
  width: 100%;
  display: inline-block;
  vertical-align: middle;
}

i {
  color: #3291F8;
}

#zheZao1 .label_1 {
  width: 34px;
  height: 34px;
}

#zheZao1 #info {
  background-repeat: no-repeat;
  background-image: url('../components/LOGO.png');
  background-size: cover;
  max-width: 301px;
  padding: 161px 23px 32px 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/check.vue